import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "../App";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) { navigate("/"); return; }
    (async () => {
      try {
        const r = await axios.post(`${API}/auth/session`, { session_id });
        setUser(r.data);
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true, state: { user: r.data } });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <img
          src="https://customer-assets.emergentagent.com/job_sumanya-collection/artifacts/v848dqa8_Sumanya_logo_hd-removebg-preview.png"
          alt="Sumanya" className="h-20 mx-auto mb-4"
        />
        <p className="text-[#8A8480] text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
